import itMessages from '../locales/it_IT.json';
import merchandisingMessages from '../locales/merchandising';

const ItLang = {
  messages: {
    ...merchandisingMessages,
    ...itMessages,
  },
  locale: 'it-IT',
};
export default ItLang;
